document.addEventListener('DOMContentLoaded', function() {
    jQuery(document).ready(function($) {

        // Updated focus to cart when product is added to cart
        $(document).on('shopifyAddToCartSuccess', function (event, data) {
            setTimeout(function(){
                console.log('trigger focus');
                $('.cart-popup').attr('tabindex', '-1').trigger('focus');
            }, 2000)
        });

        // Update Aria Pressed on product options
        $('.product-form__controls-group').on('click', 'button', function () {
            $(this)
                .attr('aria-pressed', 'true')
                .siblings('button')
                .attr('aria-pressed', 'false');
        });
    });
});